import { createSelector } from '@ngrx/store';
import { featureSelect } from '../settings';

export const getErrors = createSelector(
    featureSelect,
    (response) => response.errors
)
